<template>
	<sf-modal-layout size="xl" :title="getMessage_('QWCC001849')" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<ppr-no-popup-search
						ref="pprNoPopupSearch"
						:scrId="scrId"
						:propPartNo="propPartNo"
						:flgOsGrp="this.flgOsGrp"
						:flgPqyapGrp="this.flgPqyapGrp"
						:flgPqyrvGrp="this.flgPqyrvGrp"
						:flgPqyrgGrp="this.flgPqyrgGrp"
						:flgPqycpGrp="this.flgPqycpGrp"
					/>
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="pb-3 border-0 bg-transparent h-100">
					<ppr-no-popup-table ref="table" @close="close" @reload="reload" @SendData="sendData" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/pqy/pcku/PrtRpt/store/helpers';
import PprNoPopupSearch from '@qms/pqy/pcku/PrtRpt/Content/Popup/PprNoPopup/PprNoPopupSearch.vue';
import PprNoPopupTable from '@qms/pqy/pcku/PrtRpt/Content/Popup/PprNoPopup/PprNoPopupTable.vue';
// import PprNoPopupSearch from './PprNoPopup/PprNoPopupSearch.vue';
// import PprNoPopupTable from './PprNoPopup/PprNoPopupTable.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		flgOsGrp: { type: Boolean, default: false }, // 시스템 관리자
		flgPqyapGrp: { type: Boolean, default: false }, //승인자
		flgPqyrvGrp: { type: Boolean, default: false }, //검토자
		flgPqyrgGrp: { type: Boolean, default: false }, //작성자
		flgPqycpGrp: { type: Boolean, default: false } //외부협력사
	},
	data() {
		return {
			show: false,
			propPartNo: ''
		};
	},
	components: { PprNoPopupSearch, PprNoPopupTable },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.show = true;
			this.propPartNo = param;
			if (this.$refs.pprNoPopupSearch != undefined) {
				this.$refs.pprNoPopupSearch.reset(param);
				this.$refs.pprNoPopupSearch.searchList(param);
			}
		},
		close() {
			this.$refs.pprNoPopupSearch.reset();
			this.show = false;
		},
		sendData(row) {
			//console.log('PprNoPopup row>>> ', row);
			this.$emit('PprSendData', row);
			this.close();
		},
		reload() {
			this.$refs.pprNoPopupSearch.searchList();
		}
	}
};
</script>

<style></style>
